export enum BaseCredentialApplicationReportFields {
  id = 'id',
  externalSystemId = 'externalSystemId',
  credentialApplicationDefinitionId = 'credentialApplicationDefinitionId',
  credentialApplicationType = 'credentialApplicationType',
  credentialApplicationNumber = 'credentialApplicationNumber',
  credentialApplicationStartDate = 'credentialApplicationStartDate',
  credentialApplicationEndDate = 'credentialApplicationEndDate',
  credentialApplicationUpdatedBy = 'credentialApplicationUpdatedBy',
  credentialApplicationUpdatedOn = 'credentialApplicationUpdatedOn',
  credentialApplicationCreatedOn = 'credentialApplicationCreatedOn',
  credentialDefinitionId = 'credentialDefinitionId',
  credentialName = 'credentialName',
  systemStatus = 'systemStatus',
  renewalApplicationStatus = 'renewalApplicationStatus',
  applicationStatusLabel = 'applicationStatusLabel',
  reinstateApplicationStatus = 'reinstateApplicationStatus',

}
